import {
  ChangeDetectionStrategy,
  Component,
  Input,
  ViewEncapsulation,
} from '@angular/core';

export enum TestIds {
  Message = 'message',
  Toggle = 'toggle',
}

@Component({
  selector: 'procure-post-message',
  templateUrl: './post-message.component.html',
  styleUrl: './post-message.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class PostMessage {
  @Input() message?: string | null;

  readonly TestIds = TestIds;
}
